import { computed, makeObservable } from 'mobx';
import { ItemAvid } from 'src/types/proto/transactions';
import Item, { type ItemStore, type ItemJson } from './item';

export type AvidJson = ItemJson<'AVID'> & {
  avid: ItemAvid;
};

export default class Avid extends Item<ItemStore, AvidJson> {
  constructor(store: ItemStore, json: AvidJson) {
    super(store, json);

    makeObservable(this);
  }

  @computed
  get flows() {
    return this.kindItem.avidFlows;
  }

  @computed
  get status() {
    return this.kindItem.status;
  }

  @computed
  get hasMulti() {
    return this.flows && this.flows.length > 1;
  }

  @computed
  get fillRole() {
    return this.kindItem.fillRole;
  }

  @computed
  get agentInviteMessage() {
    return this.kindItem.agentInviteMessage;
  }

  @computed
  get attachmentTdvIds() {
    return this.kindItem.attachmentTdvIds || [];
  }

  @computed
  get attachmentTdvs() {
    return this.attachmentTdvIds
      .map((tdvId) => this.store.itemsById.get(tdvId))
      .filter((x) => x);
  }
}
